import { Action } from 'redux';

import { isRequestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { isFilterContentTypeAction } from '../../actions/ContentExplorerFilterActions';
import { isEnterSpaceAction } from '../../actions/EnterSpaceAction';
import { isFilterContentAction } from '../../actions/filters/FilterActions';
import { isResetContentBusyFetchingAction, isSpaceContentsRequestFailedAction, isSpaceContentsRequestSucceededAction, isSpaceContentsWithTokenRequestSucceededAction } from '../../actions/RequestSpaceContentsActions';
import { isSetOrderAction } from '../../actions/SetOrderAction';

export function contentFetchBusyReducer(
  previousState: boolean = false,
  action: Action = null
): boolean {
  if (isBusyFetching(action)) {
    return true;
  }

  if (isResetContentBusyFetchingAction(action)) {
    return false;
  }

  if (isSpaceContentsRequestSucceededAction(action)
    || isSpaceContentsRequestFailedAction(action)
    || isSpaceContentsWithTokenRequestSucceededAction(action)) {
    // items received, no longer busy fetching items
    return false;
  }

  // if something goes wrong while fetching items
  // we set isBusy back to false or it could stay in a incorrect state
  // as isProjectContentsRequestSucceededAction won't have been called
  if (isRequestFailed(action)) {
    return false;
  }

  return previousState;
}

function isBusyFetching(action: Action) {
  // These are all actions that will trigger
  // getting new set of content to be shown
  return isFilterContentTypeAction(action)  // changing content types for the project space
    || isFilterContentAction(action)  // setting filters
    || isSetOrderAction(action)
      // TFS853817 sorting can take a while: use SetOrder over SortContent because SortContent can be dispatched
      // even if the sort order didn't change (e.g., default sort order in the url) which means we won't re-fetch
      // the content and then won't change isBusyFetching to false.
    || isEnterSpaceAction(action);  // entering a new space
}
